import { _sharedActionsConstantsSW } from "./actions";
import { NAMED_CACHE_NAMES } from "../../utils/sw/sw.constants";
import { PROGRESS_VALUE_REMOVE } from "./constants";

export const _sharedStateSW = {
  isSWRegistered: false,
  isSWInit: false,
  isSWInitStatusRetrieved: false,

  // Urls
  websiteUrls: [],
  isWebsiteUrlsDownloading: false,
  isErrorWebsiteDownload: false,
  websiteUrlsProgress: 0,
  websiteUrlsStatuses: [],
  // ===================

  // Downloaded
  namedCacheKeysAvailable: NAMED_CACHE_NAMES.reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {}),
  // ====================

  downloadProgresses: NAMED_CACHE_NAMES.reduce((acc, key) => {
    acc[key] = {};
    return acc;
  }, {}),
};

export const _sharedReducerSW = (state = _sharedStateSW, { type, data }) => {
  switch (type) {
    case _sharedActionsConstantsSW.UPDATE_IS_SW_REGISTERED: {
      return { ...state, isSWRegistered: data, };
    }
    case _sharedActionsConstantsSW.UPDATE_IS_SW_INIT: {
      return { ...state, isSWInit: data, };
    }
    case _sharedActionsConstantsSW.UPDATE_IS_SW_INIT_DATA_RETRIEVED: {
      return { ...state, isSWInitStatusRetrieved: data, };
    }

    case _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS: {
      return {
        ...state,
        websiteUrls: data,
      };
    }

    case _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS_STATUSES: {
      return {
        ...state,
        websiteUrlsStatuses: {
          ...state.websiteUrlsStatuses,
          ...data,
        },
      };
    }
    case _sharedActionsConstantsSW.UPDATE_IS_WEBSITE_DOWNLOADING: {
      return { ...state, isWebsiteUrlsDownloading: data, };
    }
    case _sharedActionsConstantsSW.UPDATE_IS_ERROR_WEBSITE_DOWNLOAD: {
      return { ...state, isErrorWebsiteDownload: data, };
    }
    case _sharedActionsConstantsSW.UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS: {
      return { ...state, websiteUrlsProgress: data, };
    }

    case _sharedActionsConstantsSW.UPDATE_KEYS_AVAILABLE: {
      const {cacheName, keys} = data;
      const downloadProgressesNew = { ...state.downloadProgresses[cacheName] };

      // If item is downloaded delete progress automatically
      Object.keys(downloadProgressesNew).forEach((k) => {
        if (keys.includes(k)) {
          delete downloadProgressesNew[k];
        }
      });
      // ===================================================

      return {
        ...state,
        namedCacheKeysAvailable: {
          ...state.namedCacheKeysAvailable,
          [cacheName]: keys,
        },
        downloadProgresses: {
          ...state.downloadProgresses,
          [cacheName]: downloadProgressesNew,
        },
      };
    }

    case _sharedActionsConstantsSW.UPDATE_DOWNLOAD_PROGRESS: {
      const downloadProgressesNew = { ...state.downloadProgresses[data.type] };
      if (data.progress === PROGRESS_VALUE_REMOVE) {
        delete downloadProgressesNew[data.id];
      } else {
        downloadProgressesNew[data.id] = data.progress;
      }
      return {
        ...state,
        downloadProgresses: {
          ...state.downloadProgresses,
          [data.type]: downloadProgressesNew,
        },
      };
    }
    default:
      return state;
  }
};
